/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getNotificationPriorityDecoder,
  getNotificationPriorityEncoder,
  getNotificationTargetTypeDecoder,
  getNotificationTargetTypeEncoder,
  type NotificationPriority,
  type NotificationPriorityArgs,
  type NotificationTargetType,
  type NotificationTargetTypeArgs,
} from ".";

/** Notification targets */
export type NotificationTarget = {
  /** Target type */
  targetType: NotificationTargetType;
  /** Target identifier */
  targetId: string;
  /** Notification priority */
  priority: NotificationPriority;
};

export type NotificationTargetArgs = {
  /** Target type */
  targetType: NotificationTargetTypeArgs;
  /** Target identifier */
  targetId: string;
  /** Notification priority */
  priority: NotificationPriorityArgs;
};

export function getNotificationTargetEncoder(): Encoder<NotificationTargetArgs> {
  return getStructEncoder([
    ["targetType", getNotificationTargetTypeEncoder()],
    ["targetId", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["priority", getNotificationPriorityEncoder()],
  ]);
}

export function getNotificationTargetDecoder(): Decoder<NotificationTarget> {
  return getStructDecoder([
    ["targetType", getNotificationTargetTypeDecoder()],
    ["targetId", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["priority", getNotificationPriorityDecoder()],
  ]);
}

export function getNotificationTargetCodec(): Codec<
  NotificationTargetArgs,
  NotificationTarget
> {
  return combineCodec(
    getNotificationTargetEncoder(),
    getNotificationTargetDecoder(),
  );
}
